export default {
      id: "ic_link_copy-usage",
      viewBox: "0 0 31 31",
      url: "/" + "images/icons.3.109.2.svg#ic_link_copy-usage",
      toString: function () {
        return this.url;
      }
    }